module.exports = __webpack_public_path__ + "static/img/icon_szh_zhptyy_ks_zhyq.26328ebd.png";